import { CartItem } from "../classes/Item";
import { CART_STATES, PMT } from "../classes/Enum";

export const normaliseVariantName = (variant) => {
  switch (variant) {
    case 'PB': return 'POKEBALL';
    case 'MB': return 'MASTERBALL';
    case 'RH': return 'REVERSE HOLO';
    case 'H': return 'HOLO';
    default: return variant || 'DEFAULT';
  }
};

export const serializeCart = (items) => {
  const cart = items.map(cartItem => {
    return {
        'id': cartItem.productId,
        'variant': cartItem.variant ?? '',
        'condition': cartItem.condition ?? '',
        'count': cartItem.count
    }
  })
  return cart;
}

export const deserializeCart = (products) => {
    const cart = products.map(product => {
    return new CartItem(
      product.id,
      product.condition,
      product.variant,
      product.count,
      product.discount_type,
      product.applied_price,
      product.type
    )
  })
  return cart;
}

export const decrementCartItem = (cart, setCart, index) => {
    let updatedCart = cart;
    updatedCart[index].count -= 1;

    if (updatedCart[index].count <= 0) {
      updatedCart.splice(index, 1);
    }
    setCart([...updatedCart]);
  };

export function getButtonText(cartState, position, paymentMethod, grandTotal) {
  if (position === "left") {
    switch (cartState) {
      case CART_STATES.ITEMS:
        return "BACK";

      case CART_STATES.CHECKOUT:
        return "BACK TO CART";

      default:
        return "";
    }
  }

  if (position === "right") {
    switch (cartState) {
      case CART_STATES.ITEMS:
        return "PROCEED";

      case CART_STATES.SUCCESS:
        return "FINISH";

      default:
        if (grandTotal != null && Number(grandTotal) <= 0) return "COMPLETE ORDER";
        if (paymentMethod === PMT.PAYID) return "PAY WITH PAYID";
        return "PAY NOW";
    }
  }

  return "";
}

const CART_FLOW = [CART_STATES.ITEMS, CART_STATES.CHECKOUT, CART_STATES.SUCCESS];

export function nextCartState(current) {
  const i = CART_FLOW.indexOf(current);
  return i === -1
    ? CART_STATES.ITEMS
    : CART_FLOW[Math.min(i + 1, CART_FLOW.length - 1)];
}

export function prevCartState(current) {
  const i = CART_FLOW.indexOf(current);
  return i === -1 ? CART_STATES.ITEMS : CART_FLOW[Math.max(i - 1, 0)];
}